<template>
    <div class="bulma">
        <div class="modal"
             :class="{ 'is-active': isShown }">
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <svg class="modal-card-icon">
                        <use xlink:href="#icon-blog-settings"></use>
                    </svg>
                    <h2 class="modal-card-title">
                        {{ trans.modal_title.creation }}
                    </h2>
                    <a
                        @click="closeModal"
                        :title="trans.buttons.close"
                    >
                        <svg class="close-modal">
                            <use xlink:href="#icon-cross"></use>
                        </svg>
                    </a>
                </header>
                <section class="modal-card-body" v-if="!blogCreatedText">
                    <div class="field columns">
                        <div class="control column is-12">
                            <label class="label">
                                {{ trans.blog.creation.message }}
                            </label>
                            <input
                                :placeholder="trans.blog.creation.placeholder"
                                :class="{ 'is-danger': errorMessage }"
                                v-model="blogNameInput"
                                class="input"
                                type="text"
                            >
                            <p v-if="errorMessage" class="help is-danger">{{ errorMessage }}</p>
                        </div>
                    </div>
                </section>
                <section class="modal-card-body" v-else>
                    {{ blogCreatedText }}
                </section>
                <footer class="modal-card-foot">
                    <button
                        v-if="!blogCreatedText"
                        @click="create"
                        :disabled="isRequestInProgress"
                        class="button is-info"
                    >
                        {{ transButtons.save }}
                    </button>
                    <button
                        @click="closeModal"
                        :disabled="isRequestInProgress"
                        class="button"
                    >
                        {{ transButtons.cancel }}
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "BaseBlogCreateBlogModal",
    data() {
        return {
            blogNameInput: null,
        }
    },
    computed: {
        ...mapGetters('baseBlogManager', {
            isShown: 'baseBlogCreateBlogModalIsShown',
        }),
        ...mapGetters('baseBlogManager', [
            'trans',
            'isRequestSuccessfull',
            'isRequestInProgress',
            'errorMessage',
            'baseBlogName',
        ]),
        transButtons() {
            if (!this.blogCreatedText) {
                return {save: this.trans.buttons.create, cancel: this.trans.buttons.cancel};
            }

            return {save: this.trans.buttons.publish, cancel: this.trans.buttons.close};
        },
        blogCreatedText() {
            if (this.baseBlogName) {
                return this.replaceWildcards(
                    this.trans.blog.creation.successfull_message,
                    {name: this.baseBlogName}
                );
            }
        },
    },
    methods: {
        ...mapActions('baseBlogManager', [
            'hideBaseBlogCreateBlogModal',
            'createBlog',
            'unsetIsRequestSuccessfull',
            'unsetErrorMessage',
        ]),
        create() {
            this.createBlog(this.blogNameInput);
        },
        closeModal() {
            this.hideBaseBlogCreateBlogModal();
            this.unsetIsRequestSuccessfull();
            this.blogNameInput = null;
            this.unsetErrorMessage();
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    .close-modal {
        width: 16px;
        height: 16px;
        fill: $white;
        &:hover {
            fill: $black;
        }
    }
</style>
